export default __webpack_public_path__ + "static/media/logo.9959fd6d.png";